// extracted by mini-css-extract-plugin
module.exports = {"tabMenu":"BookTabs_tabMenu__CXb2D","tabMenu__item":"BookTabs_tabMenu__item__XcJfl","tabMenu__item_active":"BookTabs_tabMenu__item_active___G5Sg","count":"BookTabs_count__IOvmD"};